import { t } from 'i18next'

export type MessageType = 'post' | 'post_comment' | 'chat_message'

export enum ModerationActionType {
  MarkReviewed = 'mark_reviewed',
  Ban = 'ban',
  Deleted = 'deleted'
}

export type ModerationActionSeverity = 'success' | 'warning' | 'error'

export interface ModerationActionConfig {
  labelKey: string
  severity: ModerationActionSeverity
}

export const moderationActionConfig: Record<ModerationActionType, ModerationActionConfig> = {
  [ModerationActionType.MarkReviewed]: { labelKey: 'ls_moderation_mark_reviewed', severity: 'success' },
  [ModerationActionType.Ban]: { labelKey: 'ls_moderation_action_ban', severity: 'error' },
  [ModerationActionType.Deleted]: { labelKey: 'ls_moderation_action_deleted', severity: 'error' }
}

export const moderationActionLabel = (action: ModerationActionType): string =>
  t(moderationActionConfig[action].labelKey)

export const messageTypeLabelKeys: Record<MessageType, string> = {
  post: 'ls_moderation_message_type_post',
  post_comment: 'ls_moderation_message_type_post_comment',
  chat_message: 'ls_moderation_message_type_chat_message'
}

export const messageTypeLabel = (type: MessageType): string => t(messageTypeLabelKeys[type])

export interface ModerationMessage {
  id: string
  date: Date
  type: MessageType
  title: string
  body: string
  authorName: string
  authorAvatarUrl: string
  actions: ModerationActionType[]
  isReviewed: boolean
  autoModerated: boolean
  flaggedByKeyword: string
}

export type ApiActionType = 'approve' | 'delete_content' | 'ban_user'

export const actionToApiAction: Record<ModerationActionType, ApiActionType> = {
  [ModerationActionType.MarkReviewed]: 'approve',
  [ModerationActionType.Ban]: 'ban_user',
  [ModerationActionType.Deleted]: 'delete_content'
}

export interface PaginationInfo {
  page: number
  pageSize: number
  total: number
}

export interface PaginatedMessages {
  items: ModerationMessage[]
  pagination: PaginationInfo
}

export interface FlaggingRule {
  id: number
  name: string
}

export interface ModerationFilterParams {
  needsAction: boolean
  severity?: 'auto_delete' | 'review'
  dateFrom?: string
  dateTo?: string
  flaggingRuleId?: number
  page?: number
  pageSize?: number
}
